var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboxes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 352H384L352 416H160L128 352H32C14.326 352 0 366.328 0 384V464C0 490.508 21.49 512 48 512H464C490.51 512 512 490.508 512 464V384C512 366.328 497.674 352 480 352ZM507.713 180.883L445.719 20.125C440.844 7.969 429.094 0 416 0H96C82.906 0 71.156 7.969 66.281 20.125L4.287 180.883C1.453 188.23 0 196.039 0 203.914V272C0 298.508 21.49 320 48 320H464C490.51 320 512 298.508 512 272V203.914C512 196.039 510.547 188.23 507.713 180.883ZM384 160L352 224H160L128 160H79.266L117.656 64H394.344L432.734 160H384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxes);
export default __webpack_public_path__ + "static/media/inboxes.8856eee569783370358dd7bbebb6e3a6.svg";
export { ForwardRef as ReactComponent };